module.exports = __webpack_public_path__ + "static/media/icon-open-buy-big.fc624e53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-open-buy-big.svg
// module id = 1232
// module chunks = 19